import React, { useContext } from "react";
import { motion } from "framer-motion";
import { ThemeContext } from "../../hooks/ThemeContext";

const services = [
  {
    id: "tech",
    title: "Pôle Tech - VPS & Hébergement",
    desc: "Hébergement sécurisé, anti-DDoS, sauvegardes automatiques et gestion sur-mesure.",
  },
  {
    id: "crea",
    title: "Pôle Créatif - Branding & Design",
    desc: "Identité visuelle, logos, chartes et assets pour booster votre image.",
  },
  {
    id: "influence",
    title: "Pôle Influence - TikTok Growth",
    desc: "Stratégie créative, contenus viraux et gestion de campagnes.",
  },
  {
    id: "security",
    title: "Sécurité & Monitoring",
    desc: "Surveillance 24/7, alerting, audits et hardening des serveurs.",
  },
  {
    id: "content",
    title: "Création de Contenu",
    desc: "Vidéos, motion, visuels et community management pour conversion.",
  },
  {
    id: "analytics",
    title: "Analytics & Reporting",
    desc: "Dashboards, tracking & optimisation des performances.",
  },
];

const GroupedProducts = () => {
  const { theme } = useContext(ThemeContext);
  const isDark = theme === "dark";

  return (
    <section className="py-20">
      <div className="max-w-7xl mx-auto px-4">
        <div className={`relative overflow-hidden border p-8 md:p-10 mb-10 shadow-xl ${isDark ? "border-white/10 bg-gradient-to-br from-rose-900/20 via-purple-900/20 to-blue-900/20" : "border-rose-100/80 bg-gradient-to-br from-rose-50 via-white to-orange-50 shadow-[0_24px_70px_rgba(15,23,42,0.08)]"}`}>
          <div className={`absolute -right-10 -top-10 h-32 w-32 rounded-full ${isDark ? 'bg-rose-500/18' : 'bg-rose-200/90'}`} />
          <div className={`absolute -left-12 -bottom-12 h-40 w-40 rounded-full ${isDark ? 'bg-purple-500/10' : 'bg-purple-100/80'}`} />

          <div className="relative flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
            <div>
              <div className={`inline-flex items-center gap-2 rounded-full px-4 py-2 text-xs uppercase tracking-[0.2em] ${isDark ? 'bg-white/5 text-white/70 border border-white/10' : 'bg-white text-rose-600 border border-rose-100'}`}>
                Nos univers
              </div>
              <h2 className={`mt-4 text-4xl font-semibold ${isDark ? "text-white" : "text-gray-900"}`}>
                Nos services populaires
              </h2>
            </div>
            <p className={`max-w-xl text-lg ${isDark ? "text-white/65" : "text-gray-600"}`}>
              Un studio complet pour scaler votre marque: tech, design, contenu et influence.
            </p>
          </div>
        </div>

        <div className={`relative overflow-hidden border p-6 md:p-8 shadow-xl ${isDark ? "border-white/10 bg-white/5" : "border-rose-100/80 bg-gradient-to-br from-rose-50 via-white to-orange-50 shadow-[0_24px_70px_rgba(15,23,42,0.08)]"}`}>
          <div className={`absolute -right-10 -top-10 h-32 w-32 rounded-full ${isDark ? 'bg-rose-500/18' : 'bg-rose-200/90'}`} />
          <div className={`absolute -left-12 -bottom-12 h-40 w-40 rounded-full ${isDark ? 'bg-purple-500/10' : 'bg-purple-100/80'}`} />

          <div className="relative grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6  ">
            {services.map((s) => (
              <motion.div
                key={s.id}
                whileHover={{ y: -6 }}
                className={`${isDark ? "bg-white/[0.05] border border-white/10 hover:border-rose-400/30 hover:bg-white/[0.06]" : "bg-white/90 border border-rose-100/80 hover:border-rose-200 hover:shadow-[0_18px_40px_rgba(15,23,42,0.06)]"} p-6 transition duration-300 shadow-xl bg-white/5`}
              >
                <div className={`mb-4 inline-flex px-3 py-1 text-xs font-semibold uppercase tracking-[0.18em] border shadow-xl ${isDark ? 'bg-gradient-to-br from-rose-900/20 via-purple-900/20 to-blue-900/20 border-white/10 text-white/80' : 'bg-rose-50 text-rose-600 border-rose-100'}` }>
                  {s.id}
                </div>
                <div className="flex items-center justify-between gap-4 ">
                  <h3 className={`text-xl font-semibold ${isDark ? "text-white" : "text-gray-900"}`}>{s.title}</h3>
                  <div className={`h-3 w-3 rounded-full flex-shrink-0 ${isDark ? "bg-rose-400" : "bg-rose-500"}`} />
                </div>
                <p className={`${isDark ? "text-white/65" : "text-gray-600"} mt-3 mb-4 text-sm`}>{s.desc}</p>
                <div className="flex items-center justify-between">
                  <a href={`/services#${s.id}`} className={`text-sm font-semibold ${isDark ? "text-rose-400" : "text-rose-600"}`}>
                    En savoir plus →
                  </a>
                  <a href="/contact" className={`text-xs uppercase tracking-[0.2em] ${isDark ? "text-white/50" : "text-gray-500"}`}>
                    Devis
                  </a>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default GroupedProducts;
